<template>
  <div>
    <a-modal v-model="visible" title="Edit Tuition Program" :footer="null">
      <a-form :form="form" @submit="handleSubmit">
        <div class="row">
          <div class="col-12 col-md-8">
            <a-form-item label="Program Name">
              <a-input
                placeholder="e.g. NEET Preparation"
                v-decorator="['name', { rules: [{ required: true, message: 'Please input program name!' }] }]"
              />
            </a-form-item>
          </div>

          <div class="col-12 col-md-4">
            <a-form-item label="Code">
              <a-input
                placeholder="e.g. NEET"
                v-decorator="['code', { rules: [{ required: true, message: 'Please input program code!' }] }]"
              />
            </a-form-item>
          </div>
        </div>

        <div class="mb-2">
          <a-form-item label="Description">
            <a-textarea
              placeholder="Program description..."
              :autosize="{ minRows: 2 }"
              v-decorator="['description']"
            />
          </a-form-item>
        </div>

        <div>
          <a-form-item label="Status">
            <a-select v-decorator="['status']">
              <a-select-option :value="1">Active</a-select-option>
              <a-select-option :value="0">Inactive</a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <div class="text-right mt-4">
          <a-button class="mr-2" @click="handleCancel">Cancel</a-button>
          <a-button type="primary" html-type="submit" :loading="loading">Update Program</a-button>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'EditTuitionProgramModal',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      record: null,
    }
  },
  mounted() {
    this.$eventBus.$on('openEditTuitionProgram', this.showForm)
  },
  beforeDestroy() {
    this.$eventBus.$off('openEditTuitionProgram')
  },
  methods: {
    showForm(record) {
      this.record = record
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: record.name,
          code: record.code,
          description: record.description,
          status: record.status,
        })
      })
    },
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$nprogress.start()
          this.$http
            .patch(`/api/tuition/programs/${this.record.id}`, values)
            .then(() => {
              this.loading = false
              this.visible = false
              this.$emit('onEdited')
              this.form.resetFields()
              this.$nprogress.done()
              this.$notification.success({
                message: 'Success!',
                description: `Program "${values.name}" updated successfully.`,
              })
            })
            .catch(error => {
              this.loading = false
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        }
      })
    },
  },
}
</script>
